import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PaymentCheckoutComponent } from 'app/modules/admin/payment/components/payment-checkout/payment-checkout.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        PaymentCheckoutComponent
    ],
    declarations: [
        PaymentCheckoutComponent
    ]
})
export class SharedModule
{
}
